import { render } from "./IconHeartOutline.vue?vue&type=template&id=4cad578a"
import script from "./IconHeartOutline.vue?vue&type=script&lang=js"
export * from "./IconHeartOutline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__